import { Badge, Tab, Tabs } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useEffect, useState } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { matchPath, useLocation } from 'react-router'
import { NavigationItem } from '../../../containers/Navigation/types'
import { isNumStep } from '../../../utils/apartments'

interface MenuItemsProps extends WithTranslation {
  navigate: (arg: any) => void
  openDialog: (arg: any) => void
  navItems: NavigationItem[]
  currentPath: string
  classes: any
  unreadMessages: number
}

const tabStyles = (theme: any) => ({
  root: {
    backgroundColor: 'inherit',
    height: '69px'
  },
  wrapper: {
    padding: '0 34px',
    borderRight: '1px solid #670033',
    borderLeft: '1px solid #670033',
    //borderRight: '1px solid #54C2B7',
    //borderLeft: '1px solid #54C2B7',
    '&:last-child': {
      borderRight: 'none'
    }
  }
})

const StyledTab = withStyles({
  selected: {
    background: '#670033',
    padding: '0 35px !important',
    borderRight: 'none !important',
    borderLeft: 'none !important'
  }
})((props: any) => <Tab variant='fullWidth' {...props} />)

const NavTabs = ({
  navigate,
  navItems,
  currentPath,
  classes,
  unreadMessages,
  t
}: MenuItemsProps) => {
  const mathcedUrl: any = matchPath(window.location.pathname, {
    path: '/users/:userId/apartments/:apartmentId'
  })

  const [currentKey, setCurrentKey] = useState(currentPath)
  const location = useLocation()

  useEffect(() => {
    const navIds = navItems.map(({ id }) => id)
    if (navIds.includes(currentPath)) setCurrentKey(currentPath)
  }, [currentPath, location, navItems])

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  const BadgeIcon = ({ children, rootId }: any) => {
    return (
      <>
        {rootId === '/messages' ? (
          <Badge badgeContent={unreadMessages} color='secondary'>
            {children}
          </Badge>
        ) : (
          <>{children}</>
        )}
      </>
    )
  }

  const isClientStage = isNumStep(location.pathname, '12')
  const highlightedValue = navItems.some(({ id }) => id === currentKey)
    ? currentKey
    : navItems[0]?.id ?? ''

  return (
    <Tabs
      value={highlightedValue}
      className={classes.root}
    >
      {navItems.map(({ id, label, icon: Icon }) => {
        if (
          window.location.pathname.includes('contract')
        ) {

          if (id === '/applications' ||
            id === '/showings/overview' ||
            id === '/messages' ||
            id === '/overview' ||
            id === '/statistic' ||
            id === '/apartments'
          ) {
            return (
              <StyledTab
                value={id}
                icon={
                  <BadgeIcon rootId={id}>
                    <Icon 
                      style={
                      id.toLowerCase().includes('apartments')
                        ? {
                          marginBottom: '10px',
                          marginTop: '5px'
                        }
                        : {}
                    }
                    />
                  </BadgeIcon>
                }
                label={t(label)}
                key={id}
                disabled={isClientStage}
                className={classes.wrapper}
                onClick={() => {
                  setCurrentKey(id)
                  navigate(
                    id.toLowerCase().includes('apartments') || id.toLowerCase().includes('messages')
                      ? id
                      : mathcedUrl.url + id
                  )
                  scrollToTop()
                }}
              />
            )
          }
          return null
        }
        else if (
          mathcedUrl?.params?.apartmentId &&
          mathcedUrl?.params?.userId &&
          (id === '/applications' ||
            id === '/showings/overview' ||
            id === '/messages' ||
            id === '/overview' ||
            id === '/statistic') &&
          !location.pathname.includes('steps')
        ) {
          return (
            <StyledTab
              value={id}
              icon={
                <BadgeIcon rootId={id}>
                  <Icon />
                </BadgeIcon>
              }
              label={t(label)}
              key={id}
              disabled={isClientStage}
              className={classes.wrapper}
              onClick={() => {
                setCurrentKey(id)
                navigate(mathcedUrl.url + id)
                scrollToTop()
              }}
            />
          )
        } else if (
          ((!(mathcedUrl?.params?.apartmentId && mathcedUrl?.params?.userId) ||
            location.pathname.includes('steps')) &&
            (id === '/profile' || id === '/tenants')) ||
          id.toLowerCase().includes('apartments')
        ) {
          return (
            <StyledTab
              value={id}
              icon={
                <BadgeIcon rootId={id}>
                  <Icon
                    style={
                      id.toLowerCase().includes('apartments')
                        ? {
                          marginBottom: '10px',
                          marginTop: '5px'
                        }
                        : {}
                    }
                  />
                </BadgeIcon>
              }
              label={t(label)}
              key={id}
              disabled={isClientStage}
              className={classes.wrapper}
              onClick={() => {
                setCurrentKey(id)
                navigate(id)
                scrollToTop()
              }}
            />
          )
        }
        return null
      })}
    </Tabs>
  )
}
export default withTranslation()(
  withStyles(tabStyles, { withTheme: true })(NavTabs) as any
) as any
